import { defineStyle, defineStyleConfig } from '@chakra-ui/react';

const primary = defineStyle({
  bg: 'navyBlue',
  color: 'white',
  fontWeight: 'medium',
  rounded: 'md',
  _hover: {
    bg: 'navyBlueLight',
  },
});

const secondary = defineStyle({
  bg: 'white',
  color: 'navyBlue',
  border: '1px solid',
  borderColor: 'navyBlue',
  fontWeight: 'medium',
  rounded: 'md',
  _hover: {
    borderColor: 'white',
  },
});

const sm = defineStyle({
  fontSize: 'sm',
  height: '32px',
});

const md = defineStyle({
  fontSize: 'md',
  height: '36px',
});

const buttonTheme = defineStyleConfig({
  sizes: { sm, md },
  variants: { primary, secondary },
});

export default buttonTheme;
